import React from 'react';
import classes from 'classnames';
import styles from './PageLoader.module.scss';
import AppLoaderCircle from '@/components/AppLoaderCircle';

interface PageLoaderProps {
  className?: string;
  title?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ className, title }) => {
  return (
    <div
      className={classes(styles.loadingContainer, {
        [className || '']: !!className,
      })}
    >
      <div>
        <AppLoaderCircle className={styles.loaderCicle} />
      </div>
      {title && <p className={styles.loadingText}>{title}</p>}
    </div>
  );
};

export default PageLoader;
